import type { AppState } from '@store/types'

export const confirmStateSelector = (state: AppState) => state.confirmation2

export const confirmedActionsSelector = (state: AppState) =>
  confirmStateSelector(state)?.then || []
